import actions from './actions';
import { configOperations } from '../config';
import types from "../resource/types";


const setCurrentResource = actions.setCurrentResource;
const setResourceFields = actions.setResourceFields;
const setRequestFields = actions.setRequestFields;
const clearCurrentResource = actions.clearCurrentResource;
const setInitialResourceFilter = actions.setInitialResourceFilter;
const updateResourceFilterValues = actions.updateResourceFilterValues;
const updateResourceSqlFilter = actions.updateResourceSqlFilter;
const clearResourceFilters = actions.clearResourceFilters;
const setDispatch = actions.setDispatch;


const setInitialResourceListColumns = columnNames => (dispatch, getState) => {
  // used to initially set columns for a user or
  // at a later time reset them to a configured default array of column names
  dispatch(actions.setInitialResourceListColumns(columnNames));

  dispatch(
    configOperations.setResourceListColumns(
      getState().resource.resourceListColumns
    )
  );
};

const addResourceListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.addResourceListColumn(columnName, indexPosition));

  dispatch(
    configOperations.setResourceListColumns(
      getState().resource.resourceListColumns
    )
  );
};

const removeResourceListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.removeResourceListColumn(columnName, indexPosition));

  dispatch(
    configOperations.setResourceListColumns(
      getState().resource.resourceListColumns
    )
  );
};


export default {
  setCurrentResource,
  setDispatch,
  setResourceFields,
  setRequestFields,
  clearCurrentResource,
  setInitialResourceFilter,
  updateResourceFilterValues,
  updateResourceSqlFilter,
  clearResourceFilters,
  setInitialResourceListColumns,
  addResourceListColumn,
  removeResourceListColumn
};



// WEBPACK FOOTER //
// ./src/redux/resource/operations.js